import { capitalize } from "lodash";
import React from "react";

import "../../../styles/tutorial.scss";

function KenoDivertidu({ name }) {
  return (
    <div class="container_como_jogar">
      <div>
        <h1 className="center capitalize">{name}</h1>

        <p>
          Já pensou em ganhar até R$400.000,00 mil concorrendo em sorteios a
          cada 20 minutos, pagando apenas R$2,00 reais? O{" "}
          <b className="capitalize">{name}</b> é a modalidade ideal para você.
        </p>
        <p>
          Serão sorteados 20 números, entre 01 e 80. Apostando R$2,00 reais você
          poderá escolher 10 dezenas e a premiação é baseada na quantidade de
          acertos dos números que serão sorteados.
        </p>
      </div>
    </div>
  );
}

export default KenoDivertidu;



// WEBPACK FOOTER //
// ./src/static/tutorial/concurso/keno-divertidu.jsx